import React, { Component } from 'react';
import Header from '../../../components/Auth/Header';
import Footer from '../../../components/Auth/Footer';
import TagCreateForm from '../../../components/Auth/Tag/TagCreate';
import requireAuth from '../../../components/Auth/requireAuth';

class ScreenAdminNewTag extends Component {
	render () {
		return (
			<section>
				<Header />

				<section className="bg-primary">
					<section className="container py-3">
						<div className="row">
							<div className="col d-flex justify-content-between">
								<h2 className="mb-0 text-light text-uppercase">Tag</h2>
							</div>
						</div>
					</section>
				</section>

				<section className="container py-5">
					<TagCreateForm />
				</section>

				<Footer />
			</section>
		)
	}
}

export default requireAuth(ScreenAdminNewTag);